<div class="ipm-skeleton-beat tab-grid-object-view" *ngIf="loaderType === 'grid' else listLoader">
      <figure class="ipm-beat-grid-card">
        <div class="ipm-img-wrapper">
          <p-skeleton styleClass="ipm-image-skeleton" />
        </div>
        <figcaption class="ipm-beat-other-info-gird">
            <div class="ipm-beat-basic-details">
               <p-skeleton  styleClass="title-skeleton" />
            </div>
            <div class="ipm-beat-basic-details">
               <p-skeleton  styleClass="title-skeleton" />
            </div>
        </figcaption>
    </figure>
</div>
<ng-template #listLoader>
  <div class="list-main-layout"> 
      <ng-container *ngFor="let _ of loaderItems">
        <div class=" tab-list-object-view">
          <div class="ipm-img-wrapper">
            <p-skeleton styleClass="ipm-image-skeleton" />
          </div>
          <div class="ipm-beat-other-info-gird">
            <div class="ipm-beat-basic-details">
              <p-skeleton  styleClass="title-skeleton" />
            </div>
            <div class="ipm-beat-basic-details">
              <p-skeleton  styleClass="title-skeleton" />
            </div>
          </div>
        </div>
    </ng-container>
  </div>
</ng-template>
